module.exports = __webpack_public_path__ + "static/img/wavm8s-023-klahrk-talbot.d8f4dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wav/wavm8s-023-klahrk-talbot.png
// module id = BPvZ
// module chunks = 0